import Services from '@/utils/services'

const state = {
    isInitialized: false,
    privileges: [],
    groupMenus: [],
    categories: [],
    menus: [],
    blogCategories: [],
    tags: [],
    sliderVideoTypes: [],
    listStatuses: [
        { id: false, text: 'Không hoạt động' },
        { id: true, text: 'Hoạt động' }
    ],
    listActions: [
        { id: 1, text: 'Thêm mới' },
        { id: 2, text: 'Sửa' },
        { id: 3, text: 'Xóa' }
    ],
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    sidebarOpeningItem: null
}

const getters = {
    setting: state => property => {
        return state.appSettings[property];
    },
    getStatusName: state => statusId => {
        if (!isNaN(statusId)) {
            return state.listStatuses[statusId].text;
        } else {
            return null;
        }
    },
    getActionName: state => actionId => {
        if (!isNaN(actionId)) {
            return state.listActions[actionId - 1].text;
        } else {
            return null;
        }
    },
    menuTree: (state, getters, rootState) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var menus = state.menus.map(x => {
                return {
                    id: x.id,
                    code: x.id,
                    label: x.name,
                    hasChildren: x.hasChildren,
                    parentId: x.parentId,
                    groupMenuId: x.groupMenuId
                };
            });
            return BuildTree(menus, rootState.identity.unitId);
        } else {
            return [];
        }
    },
    categoryTree: (state, getters, rootState) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var categories = state.categories.map(x => {
                return {
                    id: x.id,
                    code: x.id,
                    label: x.name,
                    hasChildren: x.hasChildren,
                    parentId: x.parentId,
                };
            });
            return BuildTree(categories, rootState.identity.unitId);
        } else {
            return [];
        }
    },
    getSrcImage: () => fileData => {
        var src = "data:image/png;base64," + fileData;
        return src;
    }
}

const actions = {
    loadPrivileges(context) {
        return Services.get('lookup/privileges').done((data) => {
            context.commit('setPrivileges', data);
        });
    },
    loadMenus(context) {
        return Services.get('lookup/menus').done((data) => {
            context.commit('setMenus', data);
        });
    },
    loadGroupMenus(context) {
        return Services.get('lookup/group-menus').done((data) => {
            context.commit('setGroupMenus', data);
        });
    },
    loadCategories(context) {
        return Services.get('lookup/categories').done((data) => {
            context.commit('setCategories', data);
        });
    },
    loadBlogCategories(context) {
        return Services.get('lookup/blog-categories').done((data) => {
            context.commit('setBlogCategories', data);
        });
    },
    loadTags(context) {
        return Services.get('lookup/tags').done((data) => {
            context.commit('setTags', data);
        });
    },
    loadSliderVideoTypes(context) {
        return Services.get('lookup/slider-video-types').done((data) => {
            context.commit('setSliderVideoTypes', data);
        });
    },
    initializeSettings(context) {
        if (!context.state.isInitialized) {
            context.dispatch('loadPrivileges');
            context.dispatch('loadMenus');
            context.dispatch('loadCategories');
            context.dispatch('loadBlogCategories');
            context.dispatch('loadTags');
            context.dispatch('loadSliderVideoTypes');
            context.commit('initialize');
        }
    }
}

// mutations
const mutations = {
    initialize(state) {
        state.isInitialized = true;
    },
    setPrivileges(state, privileges) {
        state.privileges = privileges;
    },
    setGroupMenus(state, groupMenus) {
        state.groupMenus = groupMenus;
    },
    setMenus(state, menus) {
        state.menus = menus;
    },
    setCategories(state, categories) {
        state.categories = categories;
    },
    setBlogCategories(state, blogCategories) {
        state.blogCategories = blogCategories;
    },
    setTags(state, tags) {
        state.tags = tags;
    },
    setSliderVideoTypes(state, sliderVideoTypes) {
        state.sliderVideoTypes = sliderVideoTypes;
    },
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}

function BuildTree(roots) {
    var tree = [];
    var parents = [];
    for (var i = 0; i < roots.length; i++) {
        var currentNode = roots[i];
        if (!currentNode.parentId) {
            parents.push(currentNode);
            tree.push(currentNode);
            continue;
        }
        while (parents.length > 0) {
            var parentNode = parents[parents.length - 1];
            if (currentNode.parentId == parentNode.id) {
                if (!parentNode.children) parentNode.children = [];
                parentNode.children.push(currentNode);
                parents.push(currentNode);
                break;
            }
            parents.pop();
        }
    }
    return tree;
}
